/* VIP AUTO — scroll reveal + count-up. Touches only [data-vip-reveal] / [data-vip-count].
   Minimog's own animations (m-scroll-trigger, animations.js) are left alone.
   [data-vip-stagger] parent: its [data-vip-reveal] children get a 70ms stagger (cap 420ms).
   [data-vip-count="4.8"] / "12,500": counts 0 -> value; decimals and commas follow the attribute. */
(function () {
  'use strict';
  var vip = window.VIP = window.VIP || {};
  if (vip.motionInitialized) return;
  vip.motionInitialized = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(onHit, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;

  function fmt(n, dec, sep) {
    var p = n.toFixed(dec).split('.');
    if (sep) p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return p.join('.');
  }

  function spec(el) {
    var raw = el.getAttribute('data-vip-count') || '';
    var n = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(n)) return null;
    var dot = raw.indexOf('.');
    return { n: n, dec: dot < 0 ? 0 : raw.length - dot - 1, sep: raw.indexOf(',') > -1 };
  }

  function count(el) {
    var c = spec(el);
    if (!c) return;
    if (mq.matches) { el.textContent = fmt(c.n, c.dec, c.sep); return; }
    var t0;
    (function step(t) {
      t0 = t0 || t;
      var p = Math.min((t - t0) / 900, 1);
      el.textContent = fmt(c.n * (1 - Math.pow(1 - p, 3)), c.dec, c.sep);
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }

  function reveal(el) {
    if (io) io.unobserve(el);
    if (el.hasAttribute('data-vip-reveal') && !el.classList.contains('is-revealed')) {
      el.classList.add('is-revealed');
      if (el.style.transitionDelay) {
        el.addEventListener('transitionend', function done(e) {
          if (e.propertyName !== 'opacity') return;
          el.style.transitionDelay = '';
          el.removeEventListener('transitionend', done);
        });
      }
    }
    if (el.hasAttribute('data-vip-count') && !el._vipCounted) {
      el._vipCounted = true;
      count(el);
    }
  }

  function onHit(entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.15) reveal(e.target);
    });
  }

  function init(root) {
    root = root || document;
    if (typeof root.querySelectorAll !== 'function') return;
    var q = '[data-vip-reveal],[data-vip-count]';
    var list = Array.prototype.slice.call(root.querySelectorAll(q));
    if (root.matches && root.matches(q)) list.unshift(root);

    var parents = Array.prototype.slice.call(root.querySelectorAll('[data-vip-stagger]'));
    if (root.matches && root.matches('[data-vip-stagger]')) parents.unshift(root);
    parents.forEach(function (p) {
      var i = 0;
      Array.prototype.forEach.call(p.children, function (c) {
        if (c.hasAttribute('data-vip-reveal') && !c._vipSeen) c.style.transitionDelay = Math.min(i++ * 70, 420) + 'ms';
      });
    });

    list.forEach(function (el) {
      if (el._vipSeen) return;
      el._vipSeen = true;
      if (!io || mq.matches) { el.style.transitionDelay = ''; reveal(el); return; }
      if (el.hasAttribute('data-vip-count')) {
        var c = spec(el);
        if (c) el.textContent = fmt(0, c.dec, c.sep);
      }
      io.observe(el);
    });
  }

  function ready() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (!e.target || typeof e.target.querySelectorAll !== 'function') return;
    init(e.target);
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-vip-reveal],[data-vip-count]'), reveal);
  });
})();
